<template>
  <div class="piu-informazioni-partner">
    <b-row>
      <!--  colonna testo promo -->
      <b-col sm="12" md="8" lg="8">
        <h5>Informazioni per i partner</h5>
        <br />

        <p>
          <NomeSitoPiccolo />&nbsp; è il check-in online che può essere
          integrato nel software che fornisci ai tuoi clienti per la gestione
          della loro struttura.
        </p>

        <p>
          Attraverso un collegamento telematico tra il tuo gestionale e
          <NomeSitoPiccolo />, le informazioni personali inserite nel sito
          online potranno essere raccolte ed inserite nella banca dati della
          struttura.
        </p>

        <p>
          Possono essere gestite sia le prenotazioni raccolte direttamente in
          struttura che quelle provenienti da siti di booking online
          (Booking.com, Simplebooking, ecc.).
        </p>

        <p>
          <strong
            >Per avere un'anteprima della pagina che il cliente userà per
            inserire i suoi dati,
            <a
              target="_blank"
              :href="
                $store.state.LocalURL +
                'online/STRUTTURA_TEST?reservationcode=PRENOTAZIONE_DEMO'
              "
              >clicca qui</a
            >.</strong
          >
        </p>

        <p>
          Se desideri avere tutte le informazioni tecniche e commerciali, invia
          un messaggio compilando il form di richiesta informazioni. Sarà nostra
          cura risponderti al più presto.
        </p>

        <p>
          Il team
          <NomeSitoPiccolo />
        </p>

        <p style="text-align: right">
          <router-link to="/login">{{ labels.home_page }}</router-link>
        </p>
      </b-col>

      <b-col sm="12" md="4" lg="4">
        <div class="corpo-richiesta-informazioni">
          <b-row>
            <b-col
              cols="12"
              style="
                text-align: center;
                color: orange;
                font-size: 1.5em;
                font-weight: normal;
              "
              >{{ labels.richiesta_informazioni }}</b-col
            >
          </b-row>
          <b-form-row class="b-form-row">
            <b-col cols="12">
              <br />
              <b-form-group
                class="b-form-group"
                v-bind:label="labels.indirizzo_email_partner"
              >
                <b-form-input
                  :size="size"
                  class="b-form-input"
                  id="indirizzo-email-partner"
                  v-model="indirizzo_email_partner"
                  maxlength="255"
                ></b-form-input>
                <p
                  class="errore"
                  id="errore-email-partner"
                  v-if="isError(errori.indirizzo_email_partner)"
                >
                  {{ labels_errori[errori.indirizzo_email_partner] }}
                </p>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="b-form-row">
            <b-col cols="12">
              <b-form-group
                class="b-form-group"
                v-bind:label="labels.messaggio"
              >
                <b-form-textarea
                  style="height: 200px"
                  :size="size"
                  class="b-form-textarea"
                  id="messaggio"
                  v-model="messaggio"
                ></b-form-textarea>
                <p
                  class="errore"
                  id="errore-messaggio"
                  v-if="isError(errori.messaggio)"
                >
                  {{ labels_errori[errori.messaggio] }}
                </p>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="b-form-row">
            <b-col sm="12" md="12" lg="12" xl="12">
              <b-form-group class="b-form-group">
                <b-form-checkbox
                  id="privact"
                  v-model="privacy"
                  name="privacy"
                  unchecked-value
                  value="S"
                >
                  <i>
                    {{ labels.acconsento_al_trattamento }}
                    <b-link @click="VaiAPrivacy">{{
                      labels.leggi_informativa
                    }}</b-link>
                  </i>
                </b-form-checkbox>
                <p
                  class="errore"
                  id="errore-privacy"
                  v-if="isError(errori.privacy)"
                >
                  {{ labels_errori[errori.privacy] }}
                </p>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-row>
            <b-col cols="12">
              <br />
              <b-button
                style="width: 100%"
                variant="success"
                v-on:click="invia"
                v-bind:disabled="invio_in_corso"
                >{{ labels.invia }}</b-button
              >
            </b-col>
          </b-row>

          <b-row
            style="text-align: center"
            class="errore"
            v-if="isError(errori.invia)"
          >
            <b-col cols="12">
              {{ labels_errori[errori.invia] }}
              <br />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "ModificaUtente",
  components: {
    NomeSitoPiccolo,
  },
  data() {
    return {
      indirizzo_email_partner: "",
      messaggio: "",
      labels: {},
      labels_errori: {},
      size: "sm",
      errori: {},
      invio_in_corso: false,
      privacy: "",
    };
  },
  mixins: [utility],

  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  methods: {
    invia() {
      try {
        if (!fn_ControllaDati(this)) {
          return;
        }

        let me = this;
        let parametri = {
          indirizzo_email_partner: this.indirizzo_email_partner,
          messaggio: this.messaggio,
          lingua: this.$store.state.Lingua,
        };

        let ServerURL = this.$store.state.ServerURL;
        let parametri_json = JSON.stringify(parametri);

        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "POST",
          url: ServerURL + "CheckIn/InviaEmailRichiestaInformazioni",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$bvModal.msgBoxOk(me.labels.email_inviata, {
                title: me.labels.conferma_invio,
              });

              me.indirizzo_email_partner = "";
              me.messaggio = "";
              me.privacy = "";
            } else if (response.data.errore == -2) {
              me.registraErrore(
                response.data.esito,
                "PiuInformazioniPartner-invia"
              );
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "PiuInformazioniPartner-invia");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "PiuInformazioniPartner-invia");
      }
    },
    VaiAPrivacy() {
      let routeData = this.$router.resolve({
        name: "InformativaRichiestaInformazioni",
      });
      window.open(routeData.href, "_blank");
    },
  },
  created() {
    try {
      this.url = this.$store.state.ServerURL;
      fn_CambiaLingua(this.$store.state.Lingua, this);

      this.password = "";
    } catch (error) {
      this.registraErrore(error, "PiuInformazioniPartner-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      richiesta_informazioni: "Modulo di richiesta informazioni",
      indirizzo_email_partner: "Il mio indirizzo email è:",
      messaggio: "Messaggio",
      invia: "Invia",
      email_inviata:
        "La tua richiesta di informazioni è stata inviata correttamente",
      conferma_invio: "Conferma invio",
      confermi_messaggio_vuoto:
        "Non hai compilato il messaggio. Usereremo il tuo indirizzo email per inviarti ugualmente delle informazioni. Confermi ?",
      conferma_messaggio: "Conferma messaggio",
      home_page: "Home page",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
    };
    let labels_inglese = {
      richiesta_informazioni: "Modulo di richiesta informazioni",
      indirizzo_email_partner: "Il mio indirizzo email è:",
      messaggio: "Messaggio",
      invia: "Invia",
      email_inviata:
        "La tua richiesta di informazioni è stata inviata correttamente",
      conferma_invio: "Conferma invio",
      confermi_messaggio_vuoto:
        "Non hai compilato il messaggio. Usereremo il tuo indirizzo email per inviarti ugualmente delle informazioni. Confermi ?",
      conferma_messaggio: "Conferma messaggio",
      home_page: "Home page",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
    };
    let labels_tedesco = {
      richiesta_informazioni: "Modulo di richiesta informazioni",
      indirizzo_email_partner: "Il mio indirizzo email è:",
      messaggio: "Messaggio",
      invia: "Invia",
      email_inviata:
        "La tua richiesta di informazioni è stata inviata correttamente",
      conferma_invio: "Conferma invio",
      confermi_messaggio_vuoto:
        "Non hai compilato il messaggio. Usereremo il tuo indirizzo email per inviarti ugualmente delle informazioni. Confermi ?",
      conferma_messaggio: "Conferma messaggio",
      home_page: "Home page",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
    };
    let labels_francese = {
      richiesta_informazioni: "Modulo di richiesta informazioni",
      indirizzo_email_partner: "Il mio indirizzo email è:",
      messaggio: "Messaggio",
      invia: "Invia",
      email_inviata:
        "La tua richiesta di informazioni è stata inviata correttamente",
      conferma_invio: "Conferma invio",
      confermi_messaggio_vuoto:
        "Non hai compilato il messaggio. Usereremo il tuo indirizzo email per inviarti ugualmente delle informazioni. Confermi ?",
      conferma_messaggio: "Conferma messaggio",
      home_page: "Home page",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
    };

    let labels_errori_italiano = {
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errori: "Si è verificato un errore",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      per_favore_inserisci_messaggio:
        "Per favore inserisci il testo del messaggio",
    };
    let labels_errori_inglese = {
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errori: "Si è verificato un errore",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      per_favore_inserisci_messaggio:
        "Per favore inserisci il testo del messaggio",
    };
    let labels_errori_tedesco = {
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errori: "Si è verificato un errore",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      per_favore_inserisci_messaggio:
        "Per favore inserisci il testo del messaggio",
    };
    let labels_errori_francese = {
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errori: "Si è verificato un errore",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      per_favore_inserisci_messaggio:
        "Per favore inserisci il testo del messaggio",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "PiuInformazioniPartner-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};
    if (vm.indirizzo_email_partner.trim() == "") {
      vm.errori.indirizzo_email_partner = "dato_obbligatorio";
      esito = false;
    } else {
      let pattern = vm.$store.state.PatternEmail;
      if (!pattern.test(vm.indirizzo_email_partner)) {
        vm.errori.indirizzo_email_partner = "indirizzo_email_non_valido";
        esito = false;
      }
    }

    if (vm.messaggio.trim() == "") {
      vm.errori.messaggio = "per_favore_inserisci_messaggio";
      esito = false;
    }
    console.log(vm.privacy);
    if (vm.privacy != "S") {
      vm.errori.privacy = "privacy_obbligatoria";
      esito = false;
    }

    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "PiuInformazioniPartner-fn_ControllaDati");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.piu-informazioni-partner {
  text-align: justify;
}

.corpo-richiesta-informazioni {
  padding: 20px 40px 30px 40px;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>
